import {
  getCommcommunityAll,
  getPointLevelThreeListById,
  getPointTypeListPage
} from "@/api/point.js";
import {
  getPartsTypeListPage
} from "@/api/base.js";
export default {
  data() {
    return {
      commcommunityList: [],
      blockList: [],
      partsTypeList: [],
      pointTypeOptions: []
    }
  },
  mounted() {
    this.getCommcommunityAllFun()
    this.getPointTypeListPageFun();
    this.getPartsTypeListPageFun()
  },
  methods: {
    commcommunityChange(value) {
      this.getblockAllByCommunityIdFun(value);
    },
    // 社区列表
    async getCommcommunityAllFun() {
      const res = await getCommcommunityAll();
      this.commcommunityList = res.data.data;
    },
    // 网格列表
    async getblockAllByCommunityIdFun(id) {
      const res = await getPointLevelThreeListById({
        id: id
      });
      this.blockList = res.data.data;
    },
    // 网格列表
    async getPartsTypeListPageFun() {
      const res = await getPartsTypeListPage({
        enableStatus: 0,
        page: 1,
        size: 9999
      });
      this.partsTypeList = res.data.data.records;
    },
    // 点位类型
    async getPointTypeListPageFun() {
      const res = await getPointTypeListPage({
        enableStatus: 0,
        page: 1,
        size: 9999
      });
      this.pointTypeOptions = res.data.data.records;
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/point/pointParts/index.js